/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import {
    SET_MAIN_SETTINGS_OPTIONS_LIST,
    SET_MAIN_SETTINGS_SELECTED_OPTION,
} from './mainsettings.types';

export const setSettingsOptionsListAction = (
    optionsList: Array<{ title: string; preview: string }>,
): TivoPayloadAction<{
    optionsList: Array<{ title: string; preview: string }>;
}> => ({
    type: SET_MAIN_SETTINGS_OPTIONS_LIST,
    payload: { optionsList },
});

export const setSelectedSettingsOption = (selectedOption: {
    title: string;
    preview: string;
}): TivoPayloadAction<{ selectedOption: { title: string; preview: string } }> => ({
    type: SET_MAIN_SETTINGS_SELECTED_OPTION,
    payload: { selectedOption },
});
